module.exports = __webpack_public_path__ + "img/brasao-logo.1a49954f.png";